import { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { track } from '../../utils/analytics';

interface TourStep {
  src: string;
  alt: string;
  captionKey: string;
}

const STEPS: TourStep[] = [
  {
    src: '/tour/dashboard.png',
    alt: 'Dashboard overview screenshot',
    captionKey: 'landing.tour.step1.caption',
  },
  {
    src: '/tour/compliance.png',
    alt: 'Compliance evaluation scoring a report screenshot',
    captionKey: 'landing.tour.step2.caption',
  },
  {
    src: '/tour/calculator.png',
    alt: 'Carbon calculator with emission-factor matching screenshot',
    captionKey: 'landing.tour.step3.caption',
  },
];

export default function ProductTour() {
  const { t } = useLanguage();

  useEffect(() => {
    track('demo_view');
  }, []);

  return (
    <section id="product-tour" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('landing.tour.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('landing.tour.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((step) => (
            <div
              key={step.src}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm"
            >
              <img src={step.src} alt={step.alt} className="w-full h-auto" />
              <p className="p-4 text-sm text-gray-600">{t(step.captionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
